import styles from './DialogCamShot.module.css'
import ModalWindow from "../../../../FormTemplate/ModalWindow/ModalWindow";
import WebCamCaptureImage from "../../../../FormTemplate/WebCamCaptureImage/WebCamCaptureImage";
import React, {useEffect, useState} from "react";
import ButtonContainer from "../../../../FormTemplate/ButtonContainer/ButtonContainer";

interface IDialogCamShotProps
{
    onShot(data:string):void
    onClose():void
    frameId?:number
    maxWidth?:number
}

export default function DialogCamShot({onShot,frameId,maxWidth, onClose}:IDialogCamShotProps)
{
    const [windowWith] = useState(window.innerWidth)
    const [camWidth, setCamWidth] = useState(maxWidth ? (maxWidth < windowWith ? maxWidth : windowWith-50) : windowWith-50)
    useEffect(()=>{
        console.log(`camWidth : ${camWidth}`)
    },[camWidth])

    const handleShot = (data: string)=>{
        if(onShot) onShot(data)
    }
    return(
        <ModalWindow>
            <div className={styles.mainCont}>
                <WebCamCaptureImage
                    width={camWidth}
                    camPad={25}
                    onShot={(e)=> handleShot(e)}
                    frameId={frameId!==undefined ? frameId : -1}
                />
                <ButtonContainer resize={true} my={10} clsCont={styles.dgButton}>
                    <button type="button" className="btn btn-secondary "
                            onClick={onClose}
                    >Отмена</button>

                </ButtonContainer>

            </div>
        </ModalWindow>
    )
}